<template>
  <modal-small-refi class="support-modal" :closeBtn="true" @close="close">
    <template #header>Contact Us</template>
    <div class="content-container">
      <p>If you need to contact our concierge team, they are available by:</p>
      <section>
        <div class="email-wrapper">
          <div class="left">
            <span title="Email" class="fa-layers fa-fw">
              <font-awesome-layers>
                <font-awesome-icon icon="fa-regular fa-circle" class="circle" size="10x" />
                <font-awesome-icon icon="fa-solid fa-envelope" class="icon" transform="shrink-7" />
              </font-awesome-layers>
            </span>
          </div>
          <div class="right">
            <h2 class="row subheader">Email</h2>
            <div class="row">
              <a class="email-link" :href="`mailto:${emailAddress}`"> {{ emailAddress }}</a>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="phone-wrapper">
          <div class="left">
            <span title="Phone" class="fa-layers fa-fw">
              <font-awesome-layers>
                <font-awesome-icon icon="fa-regular fa-circle" class="circle" size="10x" />
                <font-awesome-icon icon="fa-solid fa-phone" class="icon" transform="shrink-7" />
              </font-awesome-layers>
            </span>
          </div>
          <div class="right">
            <h2 class="row subheader">Phone</h2>
            <div class="content">
              <div class="row">
                <a class="phone-link" :href="`tel:+${hrefTFN}`">{{ tollFreeNumber }}</a>
              </div>
              <div class="row">
                <span>Agents are available by phone 24 hours a day, 7 days a week.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </modal-small-refi>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ModalSmallRefi from "@/components/shared/ModalSmallRefi.vue";
import useApplicationData from "@/composables/application/useApplicationData";

export default defineComponent({
  components: { ModalSmallRefi, FontAwesomeIcon },
  setup() {
    const { tollFreeNumber, hrefTFN, emailAddress } = useApplicationData();

    return {
      tollFreeNumber,
      hrefTFN,
      emailAddress,
    };
  },
  methods: {
    close(event: any) {
      this.$emit("close", event);
    },
  },
});
</script>

<style lang="scss" scoped>
.support-modal {
  font-family: var(--body-font);
  .circle {
    background-color: var(--theme-color);
    color: var(--theme-color);
    font-size: 40px;
    border-radius: 50px;
  }

  .icon {
    height: 50px;
    width: 40px;
    color: white;
  }
}

.content-container {
  margin-top: 0;
}
h2.subheader {
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-family: var(--header-font);
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}

.underline {
  text-decoration: underline;
}

.content-container {
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  margin: 0;

  p {
    margin-top: 0;
  }

  section {
    margin-bottom: 20px;
  }

  .email-link,
  .phone-link {
    font-size: 1rem;
    color: var(--default-link-color);
  }
}

a {
  font-family: var(--body-font);
  font-size: 16px;
  font-weight: 400;
  line-height: 15px;
  text-align: left;
}

.email-wrapper,
.phone-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  .left {
    min-width: 50px;
  }
  .right {
    display: flex;
    flex-direction: column;
    .row {
      display: block;
    }
  }
}
</style>
